const NAROU_ORIGIN = 'https://ncode.syosetu.com';

export function normalizeNcode(ncode: string): string {
  return ncode.toLowerCase();
}

export function getProxyUrl(targetUrl: string): string {
  return `/api/narou/proxy?url=${encodeURIComponent(targetUrl)}`;
}

export function createTocUrl(ncode: string): string {
  return `${NAROU_ORIGIN}/${normalizeNcode(ncode)}/`;
}

export function createTocPageUrl(ncode: string, page: number): string {
  return `${createTocUrl(ncode)}?p=${page}`;
}

export function createEpisodeUrl(ncode: string, episodeNumber: number): string {
  return `${NAROU_ORIGIN}/${normalizeNcode(ncode)}/${episodeNumber}/`;
}

export function createInfoUrl(ncode: string): string {
  return `${NAROU_ORIGIN}/novelview/infotop/ncode/${normalizeNcode(ncode)}/`;
}

export function parseEpisodeUrl(
  href: string,
  baseUrl: string,
): { ncode: string; episodeNumber: number; url: string } | null {
  let pathname = href;
  if (href.startsWith('http://') || href.startsWith('https://')) {
    if (!href.includes('ncode.syosetu.com')) {
      return null;
    }
    try {
      const urlObj = new URL(href);
      pathname = urlObj.pathname;
    } catch {
      return null;
    }
  } else if (!href.startsWith('/')) {
    try {
      const urlObj = new URL(href, baseUrl);
      if (urlObj.hostname !== 'ncode.syosetu.com') return null;
      pathname = urlObj.pathname;
    } catch {
      return null;
    }
  }

  const match = pathname.match(/^\/([nN]\d{4}[a-zA-Z]{2,})\/(\d+)\/?$/);
  if (!match) {
    return null;
  }

  const ncode = normalizeNcode(match[1]);
  const episodeNumber = Number.parseInt(match[2], 10);
  return { ncode, episodeNumber, url: createEpisodeUrl(ncode, episodeNumber) };
}
